/**
 * 收件者常數
 */

import i18next from 'i18next';

// 草稿選擇要發送的來賓類型
export const RECEIVER_TYPE = {
  none: null, // 沒選任一
  choose: -1, // 自選
  all: 0, // 名單全部
  import: 1, // 匯入票
  signup: 2, // 報名票
  valid: 3, // 有效票
  validSignup: 4, // 有效報名票
};

export const RECEIVER_TYPE_SELECTIONS = [
  {
    key: RECEIVER_TYPE.none,
    name: i18next.t('common.pleaseSelectParticipant'),
    i18key: 'common.pleaseSelectParticipant',
  },
  {
    key: RECEIVER_TYPE.choose,
    name: i18next.t('common.chooseParticipant'),
    i18key: 'common.chooseParticipant',
  },
  {
    key: RECEIVER_TYPE.all,
    name: i18next.t('common.allParticipant'),
    i18key: 'common.allParticipant',
  },
  {
    key: RECEIVER_TYPE.valid,
    name: i18next.t('common.allValidParticipant'),
    i18key: 'common.allValidParticipant',
  },
  {
    key: RECEIVER_TYPE.import,
    name: i18next.t('common.allImportTicket'),
    i18key: 'common.allImportTicket',
  },
  {
    key: RECEIVER_TYPE.signup,
    name: i18next.t('common.allSignUpTicket'),
    i18key: 'common.allSignUpTicket',
  },
  {
    key: RECEIVER_TYPE.validSignup,
    name: i18next.t('common.validSignup'),
    i18key: 'common.validSignup',
  },
];
